export default __webpack_public_path__ + "static/assets/1476f7125c07b40d49c7ba85499527bb.png";